module.exports = __webpack_public_path__ + "static/media/text-width.9049393e.svg";